module.exports = __webpack_public_path__ + "img/water-drop-yellow.f8801710.svg";